import React from "react";
import Typography from "@mui/material/Typography";

const FormErrorMessageBeforeUploading = ({ errors }) => {
	return (
		(errors?.title ||
			errors?.category ||
			errors?.type ||
			errors?.language) && (
			<Typography
				variant="p"
				component={"p"}
				sx={{
					color: "grey",
					fontSize: 14,
					textAlign: "center",
				}}
			>
				Enter all the details before uploading the files
			</Typography>
		)
	);
};

export default FormErrorMessageBeforeUploading;
